import { getSubdomain } from "../../helpers/domain";

/**
 * Fonte única de verdade dos feeds de catálogo.
 *
 * Cada feed é um canal externo que consome o catálogo do tenant via XML.
 * Para adicionar um novo feed no futuro, basta incluir uma entrada aqui — as
 * telas de lista e detalhe se montam automaticamente a partir deste array.
 */
export const FEED_CHANNELS = [
    {
        slug: "google",
        name: "Google Merchant Center",
        category: "Shopping",
        color: "#4285F4",
        description:
            "Exporte seu catálogo para o Google Shopping e habilite anúncios de produtos no Google.",
        format: "RSS 2.0 (namespace g:)",
        docsUrl: "https://support.google.com/merchants/answer/7052112",
        // Configuração muda com frequência no painel do Google; em vez de manter
        // um passo a passo que envelhece, apontamos para a documentação oficial.
        instructions: [],
    },
    {
        slug: "meta",
        name: "Meta (Facebook e Instagram)",
        category: "Mídia social",
        color: "#0866FF",
        description:
            "Sincronize o catálogo com o Gerenciador de Comércio da Meta para anunciar no Facebook e Instagram.",
        format: "RSS 2.0 (namespace g:)",
        docsUrl: "https://www.facebook.com/business/help/125074381480892",
        // Configuração muda com frequência no Commerce Manager; em vez de manter
        // um passo a passo que envelhece, apontamos para a documentação oficial.
        instructions: [],
    },
    {
        slug: "freeshop",
        name: "Free Shop",
        category: "Marketplace de brindes",
        color: "#0FA958",
        description:
            "Disponibilize seu catálogo para o marketplace Free Shop consultar e listar seus produtos.",
        format: "XML",
        docsUrl: null,
        instructions: [
            "Copie a URL do feed XML abaixo.",
            "Envie a URL para a equipe do Free Shop responsável pela sua conta.",
            "O Free Shop passará a consultar o feed para manter seu catálogo atualizado no marketplace.",
        ],
    },
];

/**
 * Monta a URL pública do feed.
 *
 * O feed é servido no domínio do site (storefront) do tenant. Como heurística
 * de preview usamos o host atual, removendo o prefixo "sistema." quando presente
 * (o painel roda em sistema.<tenant> e o site em <tenant>).
 *
 * TODO(backend): trocar pela URL real retornada pela API quando o endpoint de
 * feeds existir, em vez de derivar do host.
 */
export const buildFeedUrl = (slug) => {
    const host = getSubdomain() || "";
    const siteHost = host.replace(/^sistema\./, "");
    return `https://${siteHost}/feed/${slug}.xml`;
};

export const getFeedChannel = (slug) =>
    FEED_CHANNELS.find((channel) => channel.slug === slug) || null;

export default FEED_CHANNELS;
